<template>
    <div class="pay_result">
        <div class="pay_result__panel">
            <div class="pay_result__gift">
                <img src="@/assets/imgs/order/icon-success.png" alt="">
            </div>
            <div class="pay_result__congrats">
                <img src="@/assets/imgs/order/icon-congrats.png" alt="">
            </div>
            <div class="pay_result__tips">
                Thank you for purchasing. Your order will be shipped in 2-4 working days.
            </div>

            <div class="pay_result__button" :style="[isIOS?'':{visibility: 'hidden'}]" @click="download">
                <img src="@/assets/imgs/profile/icon-download.png" alt="">
                <span>{{ $t('message.profile.download.buttonText') }}</span>
            </div>
            
            <img class="pay_result__close global_pointer" src="@/assets/imgs/close.png" alt="close" @click="$emit('close')">
        </div>
    </div>
</template>

<script>
import { plateForm } from '@/utils'
export default {
  data(){
    return{
      isIOS: plateForm().isIOS
    }
  }
}
</script>

<style lang="less" scoped>
.pay_result {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 200;
  background: rgba(0, 0, 0, 0.5);
  &__panel{
    position: absolute;
    width: 100%;
    background: #ffffff;
    left: 0;
    bottom: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    overflow: hidden;
    padding: 50px 32px 0;
    box-sizing: border-box;
  }
  &__gift{
    margin: 12px auto 0;
    width: 172px;
    height: 172px;
    line-height: 172px;
    text-align: center;
    background: #F9F9F9;
    border-radius: 100%;
    padding: 0;
    img{
        width: 70px;
        vertical-align: middle;
    }
  }
  &__congrats{
      width: 187px;
      margin: 28px auto 0;
      img{
          width: 100%;
      }
  }
  &__tips{
    width: 265px;
    height: 36px;
    margin: 20px auto 0;
    font-size: 13px;
    color: #8A8A8F;
    line-height: 18px;
  }
  &__button{
    margin: 48px auto;
    width: 311px;
    height: 46px;
    border-radius: 23px;
    background: #222222;
    display: flex;
    justify-content: center;
    align-items: center;
    & img{
      width: 26px;
      height: 26px;
      margin-right: 8px;
    }
    & span{
      height: 22px;
      font-size: 15px;
      color: #FFFFFF;
      line-height: 22px;
    }
  }
  &__close{
    width: 26px;
    height: 26px;
    position: absolute;
    right: 12px;
    top: 12px;
  }
}
</style>
<script>
import OpenApp from '@/common/openApp';
const openApp = new OpenApp();
export default {
    methods:{
    download(){
      openApp.download()
    }
  }
}
</script>